import { z } from 'zod';
import { email } from '../atomic/email';
import { phone } from '../atomic/phone';

export const emergencyContactSchema = z.object({
  // TODO rename to contact
  title: z.string().optional().nullable(),
  firstName: z
    .string()
    .min(2, { message: 'Jméno musí být dlouhé aspoň 2 znaky' }),
  lastName: z
    .string()
    .min(2, { message: 'Příjmení musí být dlouhé aspoň 2 znaky' }),
  phone,
  email,
  relation: z.string().min(1, { message: 'Vztah nesmí být prázdný' }),
});
